/**
 * How a schedule runs what it names, in one sentence (#1203). The schedule editor's What runs card
 * and the Run now dialog's "A whole schedule" both say exactly this, and the user guide takes the same wording at the Monday guide update.
 *
 * It is the runner's rule: every connection's extract is queued at once and the capacity gate
 * admits them up to the instance and connector limits (`runner/scheduler/capacity.ts`), so the
 * stored order of `dataflowIds` is not a run order. The dbt jobs start once every connection's
 * step has finished (`runner/steps/finalize.ts`, `runner/steps/transform.ts`), and only when at
 * least one extract succeeded (load steps are not consulted): `settleTransform` skips the transform with `NO_SUCCESSFUL_EXTRACT`
 * when none did.
 */
export const SCHEDULE_CONNECTIONS_RULE = "Connections run in parallel, up to the instance limit.";
export const SCHEDULE_DBT_RULE =
  "The dbt jobs run after the connections finish, when at least one connection read its data.";
export const SCHEDULE_RUN_RULE = `${SCHEDULE_CONNECTIONS_RULE} ${SCHEDULE_DBT_RULE}`;
